import React from "react";
import './Hours.css';

function Hours(businessHours) {
    
    return(
        <div>
            <h2 id="hoursHeader">Hours</h2>
            <table id="hoursTable">
                <tbody>
                    <tr className="dayRow">
                        <th>Monday</th>
                        <td>{businessHours.Monday}</td>
                    </tr>
                    <tr className="dayRow">
                        <th>Tuesday</th>
                        <td>{businessHours.Tuesday}</td>
                    </tr>
                    <tr className="dayRow">
                        <th>Wednesday</th>
                        <td>{businessHours.Wednesday}</td>
                    </tr>
                    <tr className="dayRow">
                        <th>Thursday</th>
                        <td>{businessHours.Thursday}</td>
                    </tr>
                    <tr className="dayRow">
                        <th>Friday</th>
                        <td>{businessHours.Friday}</td>
                    </tr>
                    <tr className="dayRow">
                        <th>Saturday</th>
                        <td>{businessHours.Saturday}</td>
                    </tr>
                    <tr className="dayRow">
                        <th>Sunday</th>
                        <td>{businessHours.Sunday}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default Hours;